module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("CXKcI"))).then(() => parcelRequire('hEqeo'));